<template>
   <div class="page-deliver-todo">
      <div class="pg-breadcrumb">
         <div class="breadcrumb-item em">珠海倉庫</div>
         <div class="breadcrumb-item">認領件</div>
      </div>
      <div class="card-block">
         <Form inline class="pg-form-inline">
            <FormItem>
               <Select size="small" placeholder="收件方式" v-model="form.arrive_type">
                  <Option value="1">門店</Option>
                  <Option value="2">智能櫃</Option>
               </Select>
            </FormItem>
            <FormItem>
               <Select size="small" placeholder="操作人" v-model="form.admin_id">
                  <Option :value="item.user_id" v-for="(item, index) in pickAdmin"
                          :key="item.user_id">{{ item.username }} ({{ item.realname }})
                  </Option>
               </Select>
            </FormItem>
            <FormItem>
               <DatePicker class="no-suffix" type="datetime" size="small" :clearable="false"
                           placeholder="珠海入庫-開始日期" v-model="form.start_time" value-format="yyyy-MM-dd hh:mm:ss"
                           :editable="false" style='width: 100%;'></DatePicker>
            </FormItem>
            <FormItem>-</FormItem>
            <FormItem>
               <DatePicker class="no-suffix" type="datetime" size="small" :clearable="false"
                           placeholder="珠海入庫-結束日期" v-model="form.end_time" value-format="yyyy-MM-dd hh:mm:ss"
                           :editable="false" style='width: 100%;'></DatePicker>
            </FormItem>
         </Form>
         <Form inline class="pg-form-inline form-input-wrap">
            <FormItem>
               <label class="input-label">快遞單號</label>
               <Input size="small" v-model="form.odd_numbers" @keyup.enter.native="handleSearch()"></Input>
            </FormItem>
            <FormItem>
               <div class="pg-btn-wrap">
                  <div class="pg-btn style1" @click="handleSearch">搜索</div>
               </div>
            </FormItem>
         </Form>
      </div>

      <div class="card-block pd-bt">
         <Spin fix class="pg-sub-loading" v-if="isSubmiting">
            <Icon type="ios-loading" :size="20" class="demo-spin-icon-load"></Icon>
            <div class="loading-text">Loading</div>
         </Spin>

         <Table size="small"
                border
                no-data-text="暫無數據"
                :columns="table.column"
                :data="table.data">
            <template slot-scope="{ row, index }" slot="arrive_type">
               <!-- 取货方式 1:门店取货; 2:智能柜取货-->
               <span v-if="row.arrive_type == 1">門店取貨</span>
               <span v-else-if="row.arrive_type == 2">智能櫃取貨</span>
            </template>

            <template slot-scope="{ row, index }" slot="status">
               <!-- 货物状态 0:待出库;1:已出库;2:配送中;3:代取件;4:已签收 -->
               <span v-if="row.status == 0">待出庫</span>
               <span v-else-if="row.status == 1">已出庫</span>
               <span v-else-if="row.status == 2">配送中</span>
               <span v-else-if="row.status == 3">代取件</span>
               <span v-else-if="row.status == 4">已簽收</span>
            </template>

         </Table>

         <div class="pg-pagger">
            <Row>
               <Col span="11" class="pagger-left">
                  <div class="pagger-total">總共{{ totalCount }}條記錄</div>
               </Col>
               <Col span="13" class="pagger-right">
                  <!-- v-if="totalCount > curPageSize" -->
                  <div>
                     <div class="pagger-sizer">
                        <span>每頁</span>
                        <Select v-model="curPageSize" size="small" placeholder="數量"
                                @on-change="handlePageSizeChange">
                           <Option :value="10">10</Option>
                           <Option :value="20">20</Option>
                           <Option :value="30">30</Option>
                           <Option :value="40">40</Option>
                           <Option :value="50">50</Option>
                        </Select>
                     </div>

                     <div class="pagger-elevator">
                        <span>跳轉</span>
                        <Input size="small" v-model="pageInput" @on-keyup="handlePageInput"
                               @on-enter="handlePageEnter"/>
                     </div>

                     <Page size="small"
                           :current="pageIndex"
                           :page-size="curPageSize"
                           :total="totalCount"
                           @on-change="handlePageChange">
                     </Page>
                  </div>
               </Col>
            </Row>
         </div>

      </div>

   </div>
</template>

<script>
import axios from 'axios';

export default {
   data() {
      return {
         pageIndex: 1,   //页码
         curPageSize: 10,    //一页数量
         totalCount: 1, //总条数
         pageInput: '',  //输入的页码
         pickAddress: [],    //提貨櫃點
         packageType: [],    //包裹類型
         pickAdmin: [],
         form: {
            arrive: '',    //提货柜点
            arrive_type: '',    //收件方式，1门店，2智能柜
            goods_type: '', //包裹类型
            start_time: '',
            end_time: '',
            recipient_contacts: '', //客户名称
            user_phone: '',  //客户手机号
            odd_numbers: '',    //快递单号
            sack_number: '',    //袋号
            admin_id: '',
         },
         isSubmiting: false,
         exportLink: '', //导出地址
         table: {
            column: [
               {
                  title: '出貨單號',
                  key: 'odd_numbers',
                  align: 'center',
                  sortable: true,
                  minWidth: 150
               },
               {
                  title: '客戶名稱',
                  key: 'recipient_contacts',
                  align: 'center',
                  sortable: true,
                  minWidth: 130
               },
               {
                  title: '客戶電話',
                  key: 'customer_contacts',
                  align: 'center',
                  sortable: true,
                  minWidth: 130
               },
               {
                  title: '珠海入庫時間',
                  key: 'in_time',
                  align: 'center',
                  sortable: true,
                  minWidth: 160
               },
               {
                  title: '收件方式',
                  key: 'arrive_type',
                  align: 'center',
                  slot: 'arrive_type',
                  sortable: true,
                  minWidth: 100
               },
               {
                  title: '货架号',
                  key: 'shelvesCode',
                  align: 'center',
                  sortable: true,
                  minWidth: 120
               },{
                  title: '提貨櫃點',
                  key: 'receivingName',
                  align: 'center',
                  sortable: true,
                  minWidth: 80
               },
               {
                  title: '貨物狀態',
                  key: 'status',
                  align: 'center',
                  slot: 'status',
                  sortable: true,
                  minWidth: 100
               },
               {
                  title: '操作人(珠海倉庫)',
                  key: 'actor',
                  align: 'center',
                  minWidth: 100
               }
            ],
            data: []
         }
      };
   },
   mounted() {
      this.getList();
      this.getPickAdmin();
   },
   methods: {
      //操作人
      getPickAdmin() {
         this.$Rq.requestAuth({
            url: this.$Api.pickAdmin,
            method: 'post',
            data: {
               parent_id: 1
            }
         }).then((res) => {
            if (res.code == 0) {
               this.pickAdmin = res.data.data;
            }
         });
      },
      formatDate(datetime) {
         if (!datetime) return '';

         let dateTime = new Date(datetime);
         let year = dateTime.getFullYear();
         let month = dateTime.getMonth() + 1;
         let date = dateTime.getDate();
         let hour = dateTime.getHours();
         let minute = dateTime.getMinutes();
         let second = dateTime.getSeconds();
         let milliseconds = dateTime.getMilliseconds();
         return `${this.formatNum(year)}-${this.formatNum(month)}-${this.formatNum(date)} ${this.formatNum(hour)}:${this.formatNum(second)}:${this.formatNum(milliseconds)}`;
      },
      formatNum(num) {
         return num < 10 ? '0' + num : num;
      },
      getList() {
         let form = this.form;
         this.isSubmiting = true;
         this.$Rq.requestAuth({
            url: this.$Api.scanIn,
            method: 'get',
            data: {
               // status: 0,  //0待出库, 1已出库
               offset: (this.pageIndex - 1) * this.curPageSize,
               limit: this.curPageSize,
               arrive: form.arrive,
               arrive_type: form.arrive_type,
               goods_type: form.goods_type,
               start_time: this.formatDate(form.start_time),
               end_time: this.formatDate(form.end_time),
               recipient_contacts: form.recipient_contacts,
               user_phone: '68262086',
               odd_numbers: form.odd_numbers,
               sack_number: form.sack_number,
               admin_id: form.admin_id
            }
         }).then((res) => {
            this.isSubmiting = false;
            if (res.code == 0) {
               let tempArr = [];
               let resData = res.data.data;

               for (let i = 0; i < resData.length; i++) {
                  tempArr.push({
                     id: resData[i].id,
                     recipient_contacts: resData[i].recipient_contacts,
                     in_time: resData[i].in_time,
                     odd_numbers: resData[i].odd_numbers,
                     count: resData[i].count,
                     arrive_type: resData[i].arrive_type,
                     receivingName: resData[i].store ? resData[i].store.ReceivingName : '無',
                     status: resData[i].status,
                     actor: resData[i].admininfo ? resData[i].admininfo.realname : '無',
                     customer_contacts: resData[i].recipient_phone,
                     shelvesCode: this.filterShelvesCode(resData[i].shelves?.code),
                  });
               }
               this.totalCount = res.data.count;
               this.table.data = tempArr;
            }
         }).catch((err) => {
            // this.isLoading = false;
            this.isSubmiting = false;
         });
      },
      filterShelvesCode(code) {
         if (!code) return '未上架';
         const first = code.substring(0,2).toLocaleLowerCase()
         if (first == 'ak') {
            return `澳门仓【${code}】`
         }else if (first == 'zh') {
            return `珠海仓【${code}】`
         }else {
            return code
         }
      },

      handleSearch() {
         this.pageIndex = 1;
         this.getList();
      },

      handleEdit(index) {
         let tableData = this.table.data;
         this.$router.push({path: '/deliverTodoEdit?id=' + tableData[index].id});
      },
      handleDelete(index) {
         this.$Modal.confirm({
            title: '提示',
            content: '確定刪除嗎？',
            cancelText: '取消',
            okText: '確定',
            onOk: () => {
               let tableData = this.table.data;
               this.isSubmiting = true;

               this.$Rq.requestAuth({
                  url: this.$Api.deliverDelete + '/' + tableData[index].id,
                  method: 'delete'
               }).then((res) => {
                  this.isSubmiting = false;

                  if (res.code == 0) {
                     this.$Utils.showSuccess(res.msg);

                     if (tableData.length <= 1 && this.pageIndex > 1) {
                        this.pageIndex -= 1;
                     }

                     this.getList();

                  } else {
                     this.$Utils.showTipInfo(res.msg);
                  }
               }).catch((err) => {
                  this.isSubmiting = false;
               });

            }
         });
      },

      handleExport() {
         let token = localStorage.getItem('jyb_token');
         let form = this.form;
         let params = {
            'Authorization': token,
            status: 0,  //0待出库, 1已出库
            arrive: form.arrive,
            arrive_type: form.arrive_type,
            goods_type: form.goods_type,
            start_time: this.formatDate(form.start_time),
            end_time: this.formatDate(form.end_time),
            recipient_contacts: form.recipient_contacts,
            user_phone: form.user_phone,
            odd_numbers: form.odd_numbers,
            sack_number: form.sack_number,
            admin_id: form.admin_id
         };
         let formatParams = this.$Utils.formateObjToParamStr(params);
         if (form.start_time == '') {
            this.$Utils.showTipInfo("請選擇珠海入庫起始時間");
         } else if (form.end_time == '') {
            this.$Utils.showTipInfo("請選擇珠海入庫结束時間");
         } else {
            window.open(`${this.$Api.deliverExport_old}?${formatParams}`, '_blank');
            // this.exportLink = `${this.$Api.deliverFexport}?${formatParams}`;
         }
      },

      //pager
      handlePageSizeChange(value) {
         this.pageIndex = 1;
         this.getList();
      },

      handlePageInput() {
         let value = ('' + this.pageInput).replace(/\D/g, '');
         let pageCount = Math.ceil(this.totalCount / this.curPageSize);
         if (value > pageCount) {
            value = pageCount;
         }
         this.pageInput = value;
      },
      handlePageEnter() {
         if (this.pageInput == '' || this.pageInput == this.pageIndex) return;
         if (this.pageInput == 0) {
            this.pageInput = 1;
         }
         this.pageInput = parseInt(this.pageInput);
         this.pageIndex = this.pageInput;
         this.getList();
      },

      handlePageChange(value) {
         this.pageIndex = value;
         this.getList();
      }
   }
};
</script>

<style lang="scss" scoped>
@import "DeliverClaim.scss";
</style>
